import {
  WIRCreateJourneyStepsKeys,
  WIRStageGate5SectionKey,
  WIRStageGate5Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { WIR } from 'types/wellGuardian';

export const getWirStageGate5Sections = (wir: WIR | null) =>
  (wir &&
    Object.keys(WIRStageGate5Sections)
      .map(item => ({
        label: WIRStageGate5Sections[item as WIRStageGate5SectionKey],
        value: item,
        phase: WIRCreateJourneyStepsKeys.STAGE_GATE_5,
      }))
      .filter(
        stepItem =>
          stepItem.label !== WIRStageGate5Sections.interventionSingleSlideSummary &&
          stepItem.label !== WIRStageGate5Sections.wonsCloseOut &&
          stepItem.label !== WIRStageGate5Sections.completionSchematicUpdate &&
          stepItem.label !== WIRStageGate5Sections.wellSchematicUpdate &&
          stepItem.label !== WIRStageGate5Sections.interventionWellDataStored &&
          stepItem.label !== WIRStageGate5Sections.vendorCloseOut &&
          stepItem.label !== WIRStageGate5Sections.assetCloseOutPresentation &&
          stepItem.label !== WIRStageGate5Sections.rex &&
          stepItem.label !== WIRStageGate5Sections.costConsolidationCloseOut,
      )) ??
  [];
